module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p5",
      "title": "5"
    }
  }, [_c('h1', {
    staticClass: "toctitle"
  }, [_c('span', {
    staticClass: "line_top"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p006#AA1"
    }
  }, [_vm._v("Make-It-Easy Freezer Meals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("1 "), _c('a', {
    attrs: {
      "href": "#/html/p010#AA2"
    }
  }, [_vm._v("Breakfast & Brunch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("2 "), _c('span', {
    attrs: {
      "href": "#/html/p054#AA3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef & Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("3 "), _c('span', {
    attrs: {
      "href": "#/html/p108#AA4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken & Turkey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("4 "), _c('span', {
    attrs: {
      "href": "#/html/p162#AA5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish & Seafood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("5 "), _c('span', {
    attrs: {
      "href": "#/html/p192#AA6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meatless")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("6 "), _c('span', {
    attrs: {
      "href": "#/html/p244#AA7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desserts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1a"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p296#AA8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/p297#AA9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a38fc2b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p005.vue
// module id = 69
// module chunks = 0